import Splide from '@splidejs/splide';

document.addEventListener("DOMContentLoaded", function () {

    const feedSlider = document.querySelector('.feed__slider');
    if (!feedSlider) return;

    const sbiImages = feedSlider.querySelector('#sbi_images');
    if (!sbiImages) return;

    const items = Array.from(sbiImages.querySelectorAll('.sbi_item'));
    if (!items.length) return;

    const splideEl = document.createElement('div');
    splideEl.className = 'splide feed__splide';

    const track = document.createElement('div');
    track.className = 'splide__track';

    const list = document.createElement('div');
    list.className = 'splide__list';

    items.forEach(item => {
        const slide = document.createElement('div');
        slide.className = 'splide__slide';
        slide.appendChild(item);
        list.appendChild(slide);
    });

    track.appendChild(list);
    splideEl.appendChild(track);
    sbiImages.replaceWith(splideEl);

    const slider = new Splide(splideEl, {
        type: 'slide',
        gap: '32px',
        perPage: 6,
        perMove: 6,
        trimSpace: false,
        drag: 'free',
        snap: true,
        arrows: false,
        mediaQuery: 'max',
        autoplay: false,
        interval: 4000,
        speed: 2000,
        pauseOnHover: true,
        pagination: true,
        breakpoints: {
            2000: {
                perPage: 5,
                perMove: 5,
            },
            1100: {
                perPage: 4,
                perMove: 4,
                gap: '16px',
            },
            800: {
                perPage: 3,
                perMove: 3,
            },
            600: {
                perPage: 2,
                perMove: 2,
            },
        },
    });

    slider.mount();

});
